import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'OrganizationChannelConnectionsPage.Cancel',
    defaultMessage: 'Cancel'
  },
  confirmConnectionMessage: {
    id: 'OrganizationChannelConnectionsPage.ConfirmConnectionMessage',
    defaultMessage: 'Are you sure you want to connect tenant {claimValueTenantId} as {name}?'
  },
  confirmConnectionTitle: {
    id: 'OrganizationChannelConnectionsPage.ConfirmConnectionTitle',
    defaultMessage: 'Confirm Connection'
  },
  connect: {
    id: 'OrganizationChannelConnectionsPage.Connect',
    defaultMessage: 'Connect'
  },
  loading: {
    id: 'OrganizationChannelConnectionsPage.Loading',
    defaultMessage: 'Loading...'
  },
  needHelpDescription: {
    id: 'OrganizationChannelConnectionsPage.NeedHelp',
    defaultMessage: 'Need Help? Please see our'
  },
  needHelpLink: {
    id: 'OrganizationChannelConnectionsPage.NeedHelpLinkText',
    defaultMessage: 'Channel Connections Help Center Article'
  }
})
